/**
 * What a day view knows that a block's popup needs too (v0.9.0's P2b and
 * P3): the time now, for "open 2 d" and "confirmed open 4 min ago", and whose
 * day it is, for "Written as Jordan Example, who logged it". And for the Log
 * form's Ticket field (ADR 0194): the tech's tickets, "logged by you" and
 * their status, and the time logged to each that day.
 */
import { createContext, useContext } from "react";

import type { TrayTicket } from "../../api/types";

export interface DayFacts {
  /** The day view's clock, refreshed every minute; null outside a day view. */
  now: Date | null;
  /** The display name of the tech whose day it is. */
  techName: string | null;
  /** The tech's tickets not closed (the tray's); none outside a day view. */
  tickets?: readonly TrayTicket[] | undefined;
  /** The time logged to a ticket on the day shown, its blocks' and Autotask's. */
  loggedToday?: ((ticketId: number) => number) | undefined;
}

/** Outside a day view (a component on its own in a test): the time now, and no name. */
export const DayFactsContext = createContext<DayFacts>({ now: null, techName: null });

const NONE: readonly TrayTicket[] = [];

export function useDayFacts(): {
  now: Date;
  techName: string | null;
  tickets: readonly TrayTicket[];
  loggedToday: (ticketId: number) => number;
} {
  const { now, techName, tickets, loggedToday } = useContext(DayFactsContext);
  return { now: now ?? new Date(), techName, tickets: tickets ?? NONE, loggedToday: loggedToday ?? (() => 0) };
}
